import { render, staticRenderFns } from "./TranslateModal.vue?vue&type=template&id=5a49f54e&"
import script from "./TranslateModal.vue?vue&type=script&lang=js&"
export * from "./TranslateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a49f54e')) {
      api.createRecord('5a49f54e', component.options)
    } else {
      api.reload('5a49f54e', component.options)
    }
    module.hot.accept("./TranslateModal.vue?vue&type=template&id=5a49f54e&", function () {
      api.rerender('5a49f54e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/TranslateModal.vue"
export default component.exports